import React from "react";
import { PropLabel } from "../PropX";
import * as Radio from "../Radio_v2";

type Props = {
  /**
   * The total number of skeletons to display.
   */
  count: number;

  /**
   * A label to display above the skeleton.
   * @default undefined
   */
  label?: PropLabel;

  /**
   * Testing utility function. Called with the index of the current skeleton to be rendered.
   * @default undefined
   */
  "data-testid"?(count: number): string;
};

export const ResourceLocationSkeleton: React.FC<Props> = (props) => {
  const { count, label = "Choose a datacenter region" } = props;
  const testId = props["data-testid"];

  const resources = React.useMemo(() => {
    if (count <= 0) {
      return [];
    }

    const result = new Array(count);

    for (let i = 0; i < count - 1; i++) {
      result[i] = <Radio.ButtonSkeleton key={i} data-testid={testId?.(i)} />;
    }

    result[count - 1] = <Radio.ButtonWithOverflowSkeleton key="overflow" data-testid={testId?.(count)} />;

    return result;
  }, [count]);

  return (
    <Radio.Group
      name=""
      label={label}
      selected={null}
      onSelect={() => {
        /* void */
      }}
    >
      {resources}
    </Radio.Group>
  );
};
